<template>
  <div>
    <a-spin :spinning="!isLoaded" tip="Loading...">
      <a-form v-if="dataProfile[0].length != 0" :layout="'horizontal'">
        <!-- <pre>{{ dataProfile[0] }}</pre> -->
        <a-row class="mt-10">
          <a-col :span="8" :offset="2">
            <a-form-item label="Student ID" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }" extra="">
              <a-input v-model="formBackGround.student_id" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item label="Membership ID" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
              <a-input v-model="formBackGround.membership_id" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="10" :offset="2">
            <a-form-item label="MUICAA Alumni Committee" :label-col="{ span: 12 }" :wrapper-col="{ span: 12 }" extra="">
              <a-input v-model="formBackGround.muicaa_member" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>
        <!-- dynamic name -->

        <a-row class="mt-10 mb-20">
          <a-col :span="20" :offset="2">
            <a-row type="flex">
              <a-col flex="1 1 600px">
                <a-form-item class="mt-0 mb-0" label="Title" extra="" :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }">
                  <a-select show-search placeholder="select..." option-filter-prop="children"
                    v-model="formName.title_name">
                    <a-select-option v-for="(item, index) in optionTitle" :key="index" :value="item.value">
                      {{ item.text }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item class="mt-0 mb-0" label="Academic Title" extra="" :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }">
                  <a-select show-search placeholder="select..." option-filter-prop="children"
                    v-model="formName.academic_title">
                    <a-select-option v-for="(item, index) in optionAcademicTitle" :key="index" :value="item.value">
                      {{ item.text }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <hr color="#EFF5F5" />
                <a-form-item class="mt-0 mb-0" label="First name [EN]" extra="" :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }">
                  <a-input v-model="formName.eng_first_name" placeholder="" />
                </a-form-item>
                <a-form-item class="mt-0 mb-0" label="Middle name [EN]" extra="" :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }">
                  <a-input v-model="formName.eng_middle_name" placeholder="" />
                </a-form-item>
                <a-form-item class="mt-0 mb-0" label="Last name [EN]" extra="" :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }">
                  <a-input v-model="formName.eng_last_name" placeholder="" />
                </a-form-item>
                <hr color="#EFF5F5" />
                <a-form-item class="mt-0 mb-0" label="First name [TH]" extra="" :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }">
                  <a-input v-model="formName.thai_first_name" placeholder="" />
                </a-form-item>
                <a-form-item class="mt-0 mb-0" label="Middle name [TH]" extra="" :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }">
                  <a-input v-model="formName.thai_middle_name" placeholder="" />
                </a-form-item>
                <a-form-item class="mt-0 mb-0" label="Last name [TH]" extra="" :label-col="{ span: 5 }"
                  :wrapper-col="{ span: 12 }">
                  <a-input v-model="formName.thai_last_name" placeholder="" />
                </a-form-item>
                <hr color="#EFF5F5" />
                <div class="mt-20" v-if="nameHistory">
                  <h5 class="mt-5 mb-5">
                    <a-icon type="ordered-list" /> Name History
                  </h5>
                  <a-list item-layout="horizontal" :data-source="dataProfile[0].name_detail">
                    <a-list-item slot="renderItem" slot-scope="item, index">
                      <a-list-item-meta>
                        <div slot="title">

                          <a-row type="flex">
                            <a-col flex="1 1 300px">
                              <p class="mt-5 mb-5">
                                Title :
                                {{
                                `${item.title_name_detail ? item.title_name_detail.name_eng : ''} `
                                }}
                              </p>
                            </a-col>
                            <a-col class="text-right" flex="1 2 300px">
                              <small style="font-weight: 100" class="mt-5 mb-5">
                                Update at :
                                {{
                                  moment(item.created_at).format("DD / MMMM / YYYY")
                                }}
                                {{ moment(item.created_at).format("LTS") }}
                              </small>
                            </a-col>
                          </a-row>

                          <a-row type="flex">
                            <a-col flex="1 1 300px">
                              <p class="mt-5 mb-5">
                                Academic Title :
                                {{
                                `${item.academic_title_detail ? item.academic_title_detail.name_eng : ''} `
                                }}
                              </p>
                            </a-col>
                          </a-row>

                          <a-row type="flex">
                            <a-col flex="1 1 300px">
                              <p class="mt-5 mb-5">
                                Name [EN] :
                                {{
                                `${checkEmpty(
  item.eng_first_name
)} ${checkEmpty(
  item.eng_middle_name
)} ${checkEmpty(item.eng_last_name)}`
                                }}
                              </p>
                            </a-col>
                          </a-row>

                          <a-row type="flex">
                            <a-col flex="1 1 300px">
                              <p class="mt-5 mb-5">
                                Name [TH] :
                                {{
                                `${checkEmpty(
  item.thai_first_name
)} ${checkEmpty(
  item.thai_middle_name
)} ${checkEmpty(item.thai_last_name)}`
                                }}
                              </p>
                            </a-col>
                            <a-col class="text-right" flex="1 2 300px">
                              <a-popconfirm title="Are you sure to Delete？" @confirm="removeName(item.id)">
                                <a-icon slot="icon" type="question-circle-o" style="color: red" />
                                <a-button type="danger" icon="delete"></a-button>
                              </a-popconfirm>
                            </a-col>
                          </a-row>
                        </div>
                        <!-- <div slot="description"></div> -->
                      </a-list-item-meta>
                    </a-list-item>
                  </a-list>
                  <hr color="#EFF5F5" />
                </div>
              </a-col>

              <a-col class="text-right" flex="0 1 200px">
                <a-button type="primary" @click="nameHistory = !nameHistory">
                  <a-icon :type="!nameHistory ? 'folder' : 'folder-open'" /> View
                  History
                </a-button>
              </a-col>
            </a-row>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="8" :offset="2">
            <a-form-item label="Nationality" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }" extra="">
              <a-select show-search placeholder="select..." option-filter-prop="children"
                v-model="formBackGround.nationality">
                <a-select-option v-for="(item, index) in optionNationality" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <!-- <a-col :span="8" :offset="2">
          <a-form-item
            label="Program"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
            extra=""
          >
            <a-select
              show-search
              placeholder="select..."
              option-filter-prop="children"
              v-model="formBackGround.program_code"
            >
              <a-select-option
                v-for="(item, index) in optionProgram"
                :key="index"
                :value="item.value"
              >
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
          <a-col :span="8" :offset="2">
            <a-form-item label="Major" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
              <a-select show-search placeholder="select..." option-filter-prop="children"
                v-model="formBackGround.major">
                <a-select-option v-for="(item, index) in optionMajor" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <!-- <a-form-item label="Minor" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }" extra="">
              <a-select show-search placeholder="select..." option-filter-prop="children"
                v-model="formBackGround.minor">
                <a-select-option v-for="(item, index) in optionMajor" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-form-item> -->
            <a-form-item label="Minor" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
              <a-input v-model="formBackGround.minor" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <!-- <a-col :span="8" :offset="2">
          <a-form-item
            label="Minor"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
            extra=""
          >
            <a-select
              show-search
              placeholder="select..."
              option-filter-prop="children"
              v-model="formBackGround.minor"
            >
              <a-select-option
                v-for="(item, index) in optionMajor"
                :key="index"
                :value="item.value"
              >
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
          <a-col :span="10" offset="2">
            <a-form-item label="Concentration" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" extra="">
              <a-input v-model="formBackGround.concentration" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
          <a-col :span="8" :offset="2">
            <a-form-item label="Date of Graduation" :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }" extra="">
              <a-date-picker class="mr-10" v-model="formBackGround.graduate_date" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8" :offset="2">
            <a-form-item label="G.P.A" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }" extra="">
              <a-input type="number" step="0.1" min="0.1" max="4.0" v-model="formBackGround.grade" placeholder="" />
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item label="Graduate Status" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }" extra="">
              <!-- <a-select show-search placeholder="select..." option-filter-prop="children"
                v-model="formBackGround.graduate_status">
                <a-select-option v-for="(item, index) in optionGradStatus" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select> -->
              <a-input type="text" v-model="formBackGround.graduate_status_remark" placeholder="" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8" :offset="2">
            <a-form-item label="Vital status" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }" extra="">
              <a-select show-search placeholder="select..." style="width: 80%" option-filter-prop="children"
                v-model="formBackGround.death_status">
                <a-select-option v-for="(item, index) in vitalStatusOption" :key="index" :value="item.value">
                  {{ item.name }}
                </a-select-option>
              </a-select>            </a-form-item>
          </a-col>
        </a-row>
        <!-- Submit button -->
        <a-row class="mt-20">
          <a-col :span="10" :offset="5">
            <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
              <a-button :disabled="btnSubmitLoading" type="primary" class="mr-10" @click="onSubmitBackground">
                <a-spin v-if="btnSubmitLoading" class="mr-10" />Submit
              </a-button>
              <a-button type="danger" @click="backTomain"> Back </a-button>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- End -->
      </a-form>
    </a-spin>
  </div>
</template>

<script>
const formBackGround = {
  student_id: "",
  membership_id: "",
  muicaa_member: "",
  nationality: "",
  program_code: "",
  major: "",
  minor: "",
  concentration: "",
  graduate_date: "",
  grade: "",
  graduate_status_remark: "",
  death_status:false
};
const formName = {
  academic_title: "",
  title_name: "",
  eng_first_name: "",
  eng_last_name: "",
  eng_middle_name: "",
  thai_first_name: "",
  thai_last_name: "",
  thai_middle_name: "",
};
export default {
  props: {
    dataProfile: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoaded: true,
      optionTitle: [],
      optionAcademicTitle: [],
      optionNationality: [],
      optionProgram: [],
      optionMajor: [],
      optionGradStatus: [],
      isVisibleConfirm: false,
      activeKey: [],
      nameHistory: false,
      formName: Object.assign({}, formName),
      formBackGround: Object.assign({}, formBackGround),
      arrName: [],
      //Alive or Deceased
      vitalStatusOption:[
        {
          "name":"Alive",
          "value":false
        },
        {
          "name":"Deceased",
          "value":true
        }
      ],
      // check change name
      changeValueName: {
        a: false,
        b: false,
        c: false,
        d: false,
        e: false,
        f: false,
        g: false,
      },
      // loading
      btnSubmitLoading: false
    };
  },
  watch: {
    "formName.title_name"(val) {
      this.changeValueName.a = this.checkDataChange("titlename", val);
    },
    "formName.academic_title"(val) {
      this.changeValueName.b = this.checkDataChange("academic", val);
    },
    "formName.eng_first_name"(val) {
      this.changeValueName.c = this.checkDataChange("en_f_name", val);
    },
    "formName.eng_last_name"(val) {
      this.changeValueName.d = this.checkDataChange("en_l_name", val);
    },
    "formName.eng_middle_name"(val) {
      this.changeValueName.d = this.checkDataChange("en_m_name", val);
    },
    "formName.thai_first_name"(val) {
      this.changeValueName.e = this.checkDataChange("th_f_name", val);
    },
    "formName.thai_last_name"(val) {
      this.changeValueName.f = this.checkDataChange("th_l_name", val);
    },
    "formName.thai_middle_name"(val) {
      this.changeValueName.g = this.checkDataChange("th_m_name", val);
    },
  },
  async mounted() {
    this.isLoaded = false;
    await this.setDefaultName();
    await this.getDataOption();
    this.isLoaded = true;
  },
  methods: {
    async removeName(idDel) {
      try {
        const res = await this.$http.delete(
          `/student_affair/alumni-profile-name/${idDel}/`
        );
        if (res.status === 204) {
          var jsonBody = {}
          const indexDel = this.arrName.findIndex(
            (itemDel) => itemDel === idDel
          );

          //console.log("arrName")
          //console.log(this.arrName)

          //console.log("indexDel")
          //console.log(indexDel)

          this.arrName.splice(indexDel, 1);

          //console.log("arrName")
          //console.log(this.arrName)

          jsonBody["alumin_name"] = this.arrName;
          this.updateMainProfile(jsonBody);
          // this.$emit('deleteID', { dataId: idDel })
        } else {
          throw { res };
        }
      } catch (error) {
        this.$emit("errorNotification", {
          errorMsg: error.response.status,
          urlPath: `/student_affair/alumni-profile-name/${idDel}/`,
        });
      }
    },
    backTomain() {
      this.$router
        .push({
          path: "/alumni/",
        })
        .catch((err) => { });
    },
    checkDataChange(caseCheck, valcheck) {
      if (this.dataProfile[0].name_detail.length == 0) {
        return true;
      } else {
        let lastVal = this.dataProfile[0].name_detail.length - 1;
        switch (caseCheck) {
          case "titlename":
            return (
              valcheck !== this.dataProfile[0].name_detail[lastVal].title_name
            );
            break;
          case "academic":
            // statements
            return (
              valcheck !==
              this.dataProfile[0].name_detail[lastVal].academic_title
            );
            break;
          case "en_f_name":
            // statements
            return (
              valcheck !==
              this.dataProfile[0].name_detail[lastVal].eng_first_name
            );
            break;
          case "en_l_name":
            // statements
            return (
              valcheck !==
              this.dataProfile[0].name_detail[lastVal].eng_last_name
            );
            break;
          case "en_m_name":
            // statements
            return (
              valcheck !==
              this.dataProfile[0].name_detail[lastVal].eng_middle_name
            );
            break;
          case "th_f_name":
            // statements
            return (
              valcheck !==
              this.dataProfile[0].name_detail[lastVal].thai_first_name
            );
            break;
          case "th_l_name":
            // statements
            return (
              valcheck !==
              this.dataProfile[0].name_detail[lastVal].thai_last_name
            );
            break;
          case "th_m_name":
            // statements
            return (
              valcheck !==
              this.dataProfile[0].name_detail[lastVal].thai_middle_name
            );
            break;
          default:
          // statements
        }
      }
    },
    checkEmpty(val) {
      return !["", null, "null"].includes(val) ? val : "";
    },
    getItemByOption(idFocused, fieldOption) {
      return this[fieldOption][this[fieldOption].findIndex((item) =>
        item.id === idFocused
      )].text
    }
    ,
    setDefaultName() {
      this.formBackGround =
        this.dataProfile[0].length != 0
          ? Object.assign({}, this.dataProfile[0])
          : Object.assign({}, formBackGround);
      if (this.dataProfile[0].name_detail.length != 0) {
        this.arrName = this.dataProfile[0].alumin_name;
        let pointLast = this.dataProfile[0].name_detail.length - 1;
        this.formName.title_name =
          this.dataProfile[0].name_detail[pointLast].title_name;
        this.formName.academic_title =
          this.dataProfile[0].name_detail[pointLast].academic_title;
        this.formName.eng_first_name =
          this.dataProfile[0].name_detail[pointLast].eng_first_name;
        this.formName.eng_last_name =
          this.dataProfile[0].name_detail[pointLast].eng_last_name;
        this.formName.eng_middle_name =
          this.dataProfile[0].name_detail[pointLast].eng_middle_name;
        this.formName.thai_first_name =
          this.dataProfile[0].name_detail[pointLast].thai_first_name;
        this.formName.thai_last_name =
          this.dataProfile[0].name_detail[pointLast].thai_last_name;
        this.formName.thai_middle_name =
          this.dataProfile[0].name_detail[pointLast].thai_middle_name;
      }
    },
    async getDataOption() {
      const fetchTitle = await this.$http.get(`/student_affair/title-name/`);
      const fetchAcademicTitle = await this.$http.get(`/student_affair/academic-title/`);
      const fetchNationality = await this.$http.get(
        `/student_affair/nationality/`
      );
      const fetchProgram = await this.$http.get(
        `/student_affair/program-code/`
      );
      const fetchMajor = await this.$http.get(`/student_affair/major/`);
      const fetchGradStatus = await this.$http.get(
        `/student_affair/graduate-status/`
      );
      Promise.all([
        fetchTitle,
        fetchAcademicTitle,
        fetchNationality,
        fetchProgram,
        fetchMajor,
        fetchGradStatus,
      ])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB, listC, listD, listE, listF]) => {
          this.optionTitle = listA.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng} ${item.name_thai}`,
              value: item.id,
            };
          });
          this.optionAcademicTitle = listB.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng} ${item.name_thai}`,
              value: item.id,
            };
          });
          this.optionNationality = listC.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionProgram = listD.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionMajor = listE.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionGradStatus = listF.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng} ${item.name_thai}`,
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `fail call option list`,
          });
        });
    },
    updateMainProfile(dataJson) {
      //console.log("dataJson");
      //console.log(dataJson);
      this.btnSubmitLoading = true
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-profile/" + this.dataProfile[0].id + "/",
            dataJson
          )
          .then((response) => {
            if (response.status) {
              this.$emit("updateObjMainProfile", { data: response.data });
              this.setDefaultName();
              this.changeValueName = Object.assign(
                {},
                {
                  a: false,
                  b: false,
                  c: false,
                  d: false,
                  e: false,
                  f: false,
                  g: false,
                }
              );
              this.$emit("successNotification", {
                msg: "Success",
                des: `profile update`,
              });
              this.btnSubmitLoading = false
              resolve(true);
            }
          })
          .catch((error) => {
            this.btnSubmitLoading = false
            this.$notification['error']({
            message: function (h) {
              return h("div", [
                h("strong", { class: "" }, `Failed to Update Data`),
              ]);
            },
            description:
              `Error ${error.response.status} : /student_affair/alumni-profile/`,
          });
            //console.log(error);
            resolve(false);
          });
      });
    },
    async onSubmitBackground() {
      var jsonBody = this.formBackGround//{};
      jsonBody.graduate_date = jsonBody.graduate_date ? this.moment(jsonBody.graduate_date).format("YYYY-MM-DD") : ''
      // const keys = Object.keys(this.formBackGround);
      // for (let i = 0; i < keys.length; i++) {
      //   const key = keys[i];
      //   if (
      //     [
      //       "student_id",
      //       "membership_id",
      //       "muicaa_member",
      //       "nationality",
      //       "program_code",
      //       "major",
      //       "minor",
      //       "concentration",
      //       "graduate_date",
      //       "grade",
      //       "graduate_status",
      //     ].includes(key)
      //   ) {
      //     if (!['', null, "null"].includes(this.formBackGround[key])) {
      //       jsonBody[key] =
      //         key === "graduate_date" && this.formBackGround[key] != ""
      //           ? this.moment().format("YYYY-MM-DD")
      //           : this.formBackGround[key];
      //     }
      //   }
      // }
      if (
        this.changeValueName.a ||
        this.changeValueName.b ||
        this.changeValueName.c ||
        this.changeValueName.d ||
        this.changeValueName.e ||
        this.changeValueName.f ||
        this.changeValueName.g
      ) {
        try {
          var jsonBodyName = {
            title_name: this.formName.title_name,
            academic_title: this.formName.academic_title,
            eng_first_name: this.formName.eng_first_name,
            eng_last_name: this.formName.eng_last_name,
            eng_middle_name: this.formName.eng_middle_name,
            thai_first_name: this.formName.thai_first_name,
            thai_last_name: this.formName.thai_last_name,
            thai_middle_name: this.formName.thai_middle_name,
          };
          const response = await this.$http.post(
            "/student_affair/alumni-profile-name/",
            jsonBodyName
          );
          if (response.status === 201) {
            this.arrName.push(response.data.id);
            jsonBody["alumin_name"] = this.arrName;
            this.updateMainProfile(jsonBody);
          } else {
            throw { response };
          }
        } catch (error) {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `/student_affair/alumni-profile/`,
          });
        }
      } else {
        this.updateMainProfile(jsonBody);
      }
    },
  },
};
</script>
